import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LocalizationClient } from '../remote-clients/remote-client';

@Injectable()
export class LocalizationService {
  private static _localizations: { [key: string]: string } = {};

  public currentCulture: string = '';

  constructor(private readonly _localizationClient: LocalizationClient) {}

  initialize(): Promise<void> {
    this.currentCulture = navigator.language.split('-')[0];
    return this.loadLocalizations();
  }

  async loadLocalizations(): Promise<void> {
    LocalizationService._localizations = await firstValueFrom(
      this._localizationClient.getLocalizationsByCulture(this.currentCulture)
    );
  }

  localize(key: string, ...args: any[]): string {
    key = LocalizationService._localizations[key] ?? key;

    return key.replace(/{(\d+)}/g, (match, number) =>
      args[number] ? args[number] : match
    );
  }
}
